import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

export async function ClearThisClientDocumentInfo(client, projectCode) {
	SetLotToAvailable(client, projectCode);
	var documentRef = firebase
		.database()
		.ref(
			'kavtek_clients/' +
				PROJECT_CODE.projectCode +
				'/salesAgents/' +
				client.salesAgentPointer +
				'/myClients/' +
				client.keyValue +
				'/documentInformation'
		);

	documentRef.remove();
}

export async function SetLotToAvailable(client, projectCode) {
	console.log('SetLotToAvailable: ', JSON.stringify(client));

	if (client.documentInformation?.document?.lotActive?.lotSelected) {
		var lotRef = firebase
			.database()
			.ref(
				'kavtek_clients/' +
					PROJECT_CODE.projectCode +
					'/lots/' +
					client?.documentInformation?.document.lotActive.lotSelected
			);

		lotRef.child('available').set('available');
	}
}
